import { useMemo } from "react";
import { useBranchesByCompany } from "../api/queries/organizationQueries";
import { branchOptions, managedBranchOptions } from "../utils/branchTree";
import useCurrentUser from "./useCurrentUser";
import usePermissions from "./usePermissions";

/**
 * Which branches the user may target in `module` (announcements, holidays):
 * COMPANY scope → every branch of `companyId`; BRANCH scope → only the
 * branches they manage (and their sub-branches). noneManaged = BRANCH scope
 * and nothing to target, so posting can't work.
 */
const useBranchTargets = (module, companyId) => {
  const user = useCurrentUser();
  const { companyWide, employeeId, isLoading: permsLoading } = usePermissions();
  const branchOnly = !companyWide(module, "modify");
  const query = useBranchesByCompany(companyId || user.companyId);
  const nodes = query.data;
  const options = useMemo(
    () =>
      branchOnly
        ? managedBranchOptions(nodes, employeeId)
        : branchOptions(nodes),
    [nodes, branchOnly, employeeId],
  );
  const loading = permsLoading || query.isLoading;
  return {
    branchOnly,
    options,
    loading,
    noneManaged: branchOnly && !loading && options.length === 0,
  };
};

export const BRANCH_SCOPE_HINT =
  "Your role has Branch scope here, so you can only post for branches you manage, and you don't manage any. Ask an admin to set this module to Company scope in Roles & Permissions, or to make you a branch manager.";

export default useBranchTargets;
